import { useMemo } from "react";

import { trafficSourcesForSegments } from "app/Shared/utils";
import { useTranslation } from "pro-features/components/WithTranslation";

import { trafficSources } from "../../../constants";
import { useChannelsOverviewData } from "../../useChannelsOverviewData";

import { useLegends } from "./useLegends";

export const useChartData = () => {
    const translate = useTranslation();
    const { data, isLoading: isDataLoading } = useChannelsOverviewData();
    const { competitorsLegend, myLegend, isLoading: isLegendsLoading } = useLegends();

    const { categories, translatedCategories } = useMemo(() => {
        const categoryKeys = data?.primaryData ? [...trafficSources] : [];

        return {
            categories: categoryKeys,
            translatedCategories: categoryKeys.map((key) => translate(trafficSourcesForSegments[key].title)),
        };
    }, [data?.primaryData, translate]);

    const series = useMemo(() => {
        if (!data || !categories.length) {
            return [];
        }

        return [
            {
                ...competitorsLegend,
                data: categories.map((category) => data.competitorsAverageData?.[category] ?? 0),
                pointPadding: 0.1,
                stacking: undefined,
            },
            {
                ...myLegend,
                data: categories.map((category) => data.primaryData?.[category] ?? 0),
                pointPadding: 0.25,
                stacking: undefined,
            },
        ];
    }, [data, categories, myLegend, competitorsLegend]);

    return {
        categories: translatedCategories,
        isLoading: isDataLoading || isLegendsLoading,
        series,
    };
};
